<div fxLayout="column" style="padding:15px;">

  <app-page-header [title]="pageTitle" action=''></app-page-header>

    <!--    <div fxLayout="column" fxFlex fxLayoutAlign="start center center" style="margin-top:50px;">-->
    <app-user-info *ngIf="!isUserInfoLoading && !isProvidersLoading" [user]="currentUser" [providers]="notificationProviders"></app-user-info>
    <!--    </div>-->

</div>
